module.exports = "/_next/static/images/MapsJettyMorowali-10500221a6d66d77a4b2b34114f92151.png";